import React, { useState } from "react";
import PropTypes from "prop-types";

import Button from "ui/Button";

import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import SellIcon from '@mui/icons-material/Sell';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import EventIcon from '@mui/icons-material/Event';
import { Tooltip } from "@mui/material";

import formattedDate from "utils/formattedDate";

const stateIcons = {
  completed: CheckCircleOutlineIcon,
  initiated: CancelOutlinedIcon,
  pending: PauseCircleOutlineIcon,
}

const stateIconColor = {
  completed: "success",
  initiated: "error",
  pending: "warning",
}

const stateLabels = {
  completed: "Collected",
  initiated: "Not Collected",
  pending: "Pending",
}

const generateInitialListItems = (item) => [
  {
    label: "Status",
    value: <>{stateLabels[item.redeem_state]} {item.completed_at && <strong> {formattedDate(item.completed_at)}</strong>}</>,
    icon: stateIcons[item.redeem_state],
    iconColor: stateIconColor[item.redeem_state],
  },
  ...(item.variant_label ? [{ label: "Option", value: item.variant_label, icon: SellIcon }] : []),
  { label: "Name", value: item.user_name, icon: PersonIcon },
  { label: "Email", value: item.user_email, icon: EmailIcon },
];

const generateDetailedListItems = (item) => [
  { label: "Order Id", value: item.order_id || "N/A", icon: SellIcon },
  { label: "Item Reference", value: item.uuid, icon: ConfirmationNumberIcon },
  { label: "Date of Purchase", value: formattedDate(item.created_at, 'datetime'), icon: EventIcon },
];

const Content = ({ item }) => {
  const [detailsVisible, setDetailsVisible] = useState(false);

  const listItems = detailsVisible
    ? [...generateInitialListItems(item), ...generateDetailedListItems(item)]
    : generateInitialListItems(item);

  return (
    <>
      <div className="checkin-modal-content">
        {listItems.map((entry) => (
          <div key={entry.label}>
            <Tooltip title={entry.label}>
              <entry.icon color={entry.iconColor || "warning"}/>
            </Tooltip>
            <p key={entry.label}>
              {entry.value}
            </p>
          </div>
        ))}
      </div>

      {!detailsVisible && (
        <Button iconColor="warning" smallPadded text onClick={() => setDetailsVisible(true)}>View More Details →</Button>
      )}
    </>
  );
};

Content.propTypes = {
  item: PropTypes.object.isRequired,
};

export default Content;
